import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  authorOfQuote:
    'George Schmidt,<br class="d-lg-none"/> CEO UK/Europe at Tide:',
  email: 'Email',
  getInTouchToFindOutMoreSubtitle:
    'Reach out to us and see what benefits our virtual and registered office services can provide you and your clients.',
  name: 'Name',
  ourClientsPartnerships: 'Our Clients & Partnerships',
  ourClientsPartnershipsTitle:
    'Trusted partnerships with financial institutions to reach <span class="text-bold color-purple6">over 100,000 customers to date</span>.',
  primeLondonBusinessAddressTitle:
    'Cheap London business address with 10 Minute Setup <span class="text-bold">+ NO Postage Fees!</span>',
  quote:
    '"Incorporating a virtual office address service into our company formation offering means tide now makes it quicker and easier than ever for people to register a business and get themselves up and running. Having a virtual office address allows entrepreneurs to keep their personal data private and run a professional business. As the trend towards working from home seems set to continue, we expect to see increased interest in this service."',
  sourceOfQuote: 'Source: AltFi',
  submit: 'Submit',
}
export const konnectStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
